import Vue from 'vue';

Vue.component('read-review', require('./ReadReview').default);
Vue.component('would-you-recommend', require('./WouldYouRecommend').default);
Vue.component('feedback-review', require('./FeedbackReview').default);
Vue.component('rate', require('./Rate').default);
Vue.component('share', require('./Share').default);
Vue.component('thank-you', require('./ThankYou').default);
Vue.component('review-list', require('./ReviewList').default);
Vue.component('cx-review', require('./CxReview').default);
Vue.component('nps-review', require('./NpsReview').default);
Vue.component('public-review', require('./PublicReview').default);
Vue.component('public-review-list', require('./PublicReviewList').default);
Vue.component('external-review', require('./ExternalReview').default);

Vue.component('review-list-item', require('./ReviewListItem').default);
Vue.component('reply-review-modal', require('./components/ReplyReviewModal').default);
Vue.component('reply-review-google-modal', require('./components/ReplyReviewGoogleModal').default);

// dumb components
Vue.component('review-icon', require('./components/ReviewIcon').default);
Vue.component('old-invites-overview', require('./InvitesOverview.vue').default);
Vue.component('overall-score-widget', require('./OverallScoreWidget').default);
Vue.component('nps-rating', require('./components/NpsRating').default);
